<template>
	<div class="white" style="margin-bottom: 0px; margin-top: 10px;">
		<h2 class="py-0 font-weight-semibold point7 text-xs-center">Learn More</h2>
		<v-layout row justify-space-around wrap="true" style="margin-top: 10px;">
			<v-layout row justify-space-around>
				<v-card class="darken2 boxCard" flat :hover=true>
					<router-link to="/mecfs" tag="span">
						<div class="column secondary innerBox">
							<p class="text-xs-center display-1" style="color: white" >ME/CFS</p>
						</div>
					</router-link>
				</v-card>
				<v-card class="darken2 boxCard" flat :hover=true>
					<router-link to="/about/membership" tag="span">
						<div class="column secondary innerBox">
							<p class="text-xs-center display-1" style="color: white" >Membership</p>
						</div>
					</router-link>
				</v-card>
			</v-layout>
			<v-layout row justify-space-around>
				<v-card class="darken2 boxCard" flat :hover=true>
					<router-link to="/about/services" tag="span">
						<div class="column secondary innerBox">
							<p class="text-xs-center display-1" style="color: white" >Services</p>
						</div>
					</router-link>
				</v-card>
				<v-card class="darken2 boxCard" flat :hover=true>
					<router-link to="/resources" tag="span">
						<div class="column secondary innerBox">
							<p class="text-xs-center display-1" style="color: white" >Resources</p>
						</div>
					</router-link>
				</v-card>
			</v-layout>
		</v-layout>
	</div>
</template>

<style>
.boxCard {
	height: 280px; width: 280px;
	margin-bottom: 20px; margin-top: 20px;
}
.innerBox {
	height: 96%; width: 96%;
	margin-left: 2%; margin-top: 2%;
	align-items: center; justify-content: center;
}
</style>


<script>
export default {
	name: "Boxlinks"
}
</script>